import {Injectable} from '@angular/core';
import {map, Observable} from "rxjs";
import {AddressType} from "@modules/address/models/address-type.model";
import {AddressTypesQuery} from "@generated/graphql";
import {addressTypeFactory} from "@modules/address/factories/address-type.factory";

@Injectable({
  providedIn: 'root',
})
export class AddressTypeApi {
  get addressTypesQueryRef () {
    return this.addressTypesQuery.watch()
  }

  constructor(
    private readonly addressTypesQuery: AddressTypesQuery
  ) {
  }

  get$(): Observable<AddressType[]> {
    return this.addressTypesQueryRef.valueChanges.pipe(
      map(res => addressTypeFactory.createEntities(res.data.addressTypes))
    )
  }
}
